import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import PlaceholderItem from './PlaceholderItem';
import { PlaceholderItemContainer } from '../CodeStyle';

const PlaceholdersSection = ({
  classes,
  codePlaceholders,
  onPlaceholderChange,
  onPlaceholderDelete,
  onAddPlaceholder,
  store,
}) => {
  const data = store ? store(state => state.data) : {};
  const placeholdersData = (data && data.placeholders) || [];
  return (
    <Grid container rowSpacing={3} alignItems="center">
      <Grid item xs={12}>
        <div className={classes?.label ?? ''}>Outputs</div>
      </Grid>
      <Grid item xs={12}>
        <div className={classes?.secondLevelLabel ?? ''}>
          Enter the key in the return statement to output the value of that key as a placeholder
        </div>
      </Grid>
      <Grid item xs={12}>
        <Grid container rowSpacing={2} spacing={2} alignItems={'center'}>
          <Grid item xs={3}>
            <div className={classes?.label ?? ''}>Type</div>
          </Grid>
          <Grid item xs={8}>
            <div className={classes?.label ?? ''}>Key</div>
          </Grid>
          <Grid item xs={1} />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        {codePlaceholders.map((placeholder, index) => (
          <PlaceholderItemContainer key={index}>
            <PlaceholderItem
              index={index}
              total={placeholdersData.length}
              placeholder={placeholder}
              onChange={onPlaceholderChange}
              onDelete={onPlaceholderDelete}
            />
          </PlaceholderItemContainer>
        ))}
      </Grid>
      <Grid item xs={12}>
        <Button size="medium" onClick={onAddPlaceholder}>
          <AddIcon /> Add Placeholder
        </Button>
      </Grid>
    </Grid>
  );
};

export default PlaceholdersSection;
